import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiAccordion } from '@taiga-ui/experimental';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-parent-lern',
  standalone: true,
  imports: [TuiAccordion, TranslocoDirective],
  templateUrl: './parent-lern.component.html',
  styleUrl: './parent-lern.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParentLernComponent {}
